import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Button } from 'react-bulma-components';
import Image from '../../../images/villeryo-boch-teekanne.jpg';

const Order3 = () => {

    // set document title
    useEffect(() => {
        document.title = 'Bestellungen 63849 - Maison Truffe';
    }, []);

    return (
        <>
            <section className="section-wrapper">
                <div className="section-inner">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to="/account/dashboard/">Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to="/account/bestellungen/">Meine Bestellungen</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            <Link to="/account/bestellungen/83727">Bestellung 63849</Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </section>
            <section className="section-wrapper">
                <div className="section-inner">
                    <h1>Bestellung 63849</h1>

                    <b>Bestellatum:</b> 10.09.2022<br/>
                    <b>Anzahl Artikel:</b> 1<br/>
                    <b>Total:</b> CHF 142.00<br/>
                    <br/><br/>

                    <table>
                        <thead>
                            <tr>
                                <th>Bild</th>
                                <th>Artikel</th>
                                <th>Versanddatum</th>
                                <th align="right">Preis pro Stück in CHF</th>
                                <th>Anzahl</th>
                                <th align="right">Total in CHF</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><img src={Image} alt="Bild" width="150px"/></td>
                                <td>
                                Villeroy & Boch<br/>
                                    <strong>Artesano Original Teekanne, 1 l, weiß</strong>
                                </td>
                                <td>12.09.2022</td>
                                <td align="right">142.00</td>
                                <td>1</td>
                                <td align="right">142.00</td>
                                <td>
                                    <Button title="In den Warenkorb"><span class="material-symbols-outlined">shopping_basket</span></Button>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="right"><strong>Total: CHF 142.00</strong></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    )
}

export default Order3;